import { Box } from "@mui/material"
import { SectorModal } from "./SectorModal"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface AddSectorProps {
  refetchSectors: () => void;
}

export const AddSector = ({ refetchSectors }: AddSectorProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate('/sectors');
  }

  const handleSave = () => {
    navigate('/sectors');
    refetchSectors();
  }
  
  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <Box className="add-sector">
      <SectorModal open={open} handleClose={handleClose} handleSave={handleSave} sector={{  }} />
    </Box>
  )
}